module.exports = __webpack_public_path__ + "img/de_3.0763b878.jpg";